import { PersistentStore } from "./store";
/*As of April 2023, this works in 95.42% of the browsers used globally.
Old compatibility information
ecma-402/1.0 says that timeZone may be undefined if not provided to constructor. However, future draft (3.0) fixed that issue by changing to system default timezone.
In this version of the ECMAScript Internationalization API, the timeZone property will remain undefined if no timeZone property was provided in the options object provided to the Intl.DateTimeFormat constructor. However, applications should not rely on this, as future versions may return a String value identifying the host environment’s current time zone instead.
in ecma-402/3.0 which is still in a draft it changed to
In this version of the ECMAScript 2015 Internationalization API, the timeZone property will be the name of the default time zone if no timeZone property was provided in the options object provided to the Intl.DateTimeFormat constructor. The previous version left the timeZone property undefined in this case.
*/

import CoverageService from "@/modules/coverage/CoverageService";
import errorManager from "@/modules/errors/error-services/error-manager";
import { ErrorMessage } from "@/models/ErrorMessage";
class OptionsStore extends PersistentStore {
  data() {
    return {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timezoneBrowser: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locale: Intl.DateTimeFormat().resolvedOptions().locale,
      localeBrowser: Intl.DateTimeFormat().resolvedOptions().locale,
      UTC: false,
      postion: [],
      mapzoom:18,
      navigation:{
        prewView:"/"
      }
    };
  }
  setTimezone(tz) {
    this.state.timezone = tz
      ? tz
      : Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  switchUTCTimeZone(swutc) {
    this.state.UTC = swutc;
    if (swutc) {
      this.state.timezone = null;
      this.state.locale = null;
      console.log("switch ", this.state.timezoneBrowser);
    } else {
      this.state.timezone = this.state.timezoneBrowser;
      this.state.locale = this.state.localeBrowser;
    }
    // switch (tz) {
    //     case null||undefined:
    //         this.state.timezone = null
    //         this.state.UTC=true
    //         break;
    //     default:
    //         this.setTimezone(tz)
    //         this.state.UTC=false
    //         break;
    // }
  }

  async getCurrentLocation() {
    return await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.state.position = [];
          this.state.position[0] = pos.coords.latitude;
          this.state.position[1] = pos.coords.longitude;
          this.state.mapzoom=12
          console.log(this.state.position);
          if (this.state.position.length == 0) {
            window.alert(
              "Geolocalizzazione non disponibile. Controllare privacy del browser."
            );
            this.state.mapzoom=6
            reject();
          }
          resolve(this.state.position);
        },
        () => {
          let loc = new Intl.Locale(navigator.language);
          console.log(loc);
          this.state.mapzoom=6
          this.getGeocoding(loc.region)
            .then((response) => {
              let coords = response.length > 0 ? response[0].location : null;
              if (coords) {
                this.state.position = [];
                this.state.position[0] = coords.latitude;
                this.state.position[1] = coords.longitude;
                resolve(this.state.position);
              } else {
                reject();
              }
            })
            .catch((er) => {
              console.log(er);
              reject();
            });

          if (this.state.position.length == 0) {
            window.alert(
              "Geolocalizzazione non disponibile. Controllare privacy del browser."
            );
            reject();
          }
        }
      );
    });
  }
  getGeocoding(valueRef) {
    console.log(valueRef);
    let regionNames = new Intl.DisplayNames(['en'], {type: 'region'});
    let value=regionNames.of(valueRef);  // "United States"
    return CoverageService.getGeocoding(value).then(
      (response) => {
        console.log(response);
        return Promise.resolve(response.data.results || []);
      },
      (error) => {
        console.error(error);
        let catchError = error;
        if (error.response) {
          catchError = error.response;
        }
        const status = catchError && catchError.data && catchError.data.error;
        if (status) {
          errorManager.pushError(
            new ErrorMessage(status.status, status.message, status.code)
          );
        }
        return errorManager.manage(
          catchError,
          errorManager.caseNotFound(() => Promise.resolve([])),
          errorManager.defaultCase(() => {
            //errorManager.pushError(catchError);
            return Promise.resolve({});
          })
        );
      }
    );
  }
}
export const optionsStore = new OptionsStore("OPTIONS");
